import {
  GET_ADMIN,
  GET_ADMIN_ONE,
  GET_ADMIN_SUCCESS,
  GET_ADMIN_FAIL,
  DELETE_ADMIN,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  UPDATE_ADMIN,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAIL,
  ADD_NEW_ADMIN,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAIL,
  ADMIN_LOADING,
  ADMIN_RESET,
} from "./actionType";

export const resetAdminState = (actionType) => ({
  type: ADMIN_RESET,
  payload: { actionType },
});

export const getAdminSuccess = (actionType, data) => ({
  type: GET_ADMIN_SUCCESS,
  payload: { actionType, data },
});

export const getAdminFail = (actionType, error) => ({
  type: GET_ADMIN_FAIL,
  payload: { actionType, error },
});

export const getAdmin = data => ({
  type: GET_ADMIN,
  payload: data,
});

export const getAdminOne = (data) => ({
  type: GET_ADMIN_ONE,
  payload: data,
});

export const getAdminLoading = () => ({
  type: ADMIN_LOADING
});

export const deleteAdmin = data => ({
  type: DELETE_ADMIN,
  payload: data,
});

export const deleteAdminSuccess = data => ({
  type: DELETE_ADMIN_SUCCESS,
  payload: data,
});

export const deleteAdminFail = error => ({
  type: DELETE_ADMIN_FAIL,
  payload: error,
});

export const updateAdmin = data => ({
  type: UPDATE_ADMIN,
  payload: data,
});

export const updateAdminFail = error => ({
  type: UPDATE_ADMIN_FAIL,
  payload: error,
});

export const updateAdminSuccess = data => ({
  type: UPDATE_ADMIN_SUCCESS,
  payload: data,
});

export const addNewAdmin = data => {
  return{
    type: ADD_NEW_ADMIN,
    payload: data,
  }
};

export const addAdminSuccess = data => ({
  type: ADD_ADMIN_SUCCESS,
  payload: data,
});

export const addAdminFail = error => ({
  type: ADD_ADMIN_FAIL,
  payload: error,
});